<template>
    <div class="block-item">
        <div class="top-part">
            <div class="top-left-part">
                <div v-for="(item, index) in value.top.leftList" :key="index" :name="index">{{ item }}</div>
                <!-- <div>5kWh</div> -->
                <div class="top-left-part-desc">套餐</div>
            </div>
            <div class="top-right-part">
                <div v-for="(item, index) in value.top.rightList" :key="index" :name="index" class="right-part-list-item">
                    <div class="right-part-item-title">{{ item.left }}</div>
                    <div class="right-part-item-value">{{ item.right }}</div>
                </div>
                <!-- <div class="right-part-list-item">
                    <div class="right-part-item-title">·家庭级智能柔储</div>
                    <div class="right-part-item-value">1套</div>
                </div>
                <div class="right-part-list-item">
                    <div class="right-part-item-title">·“格力+”APP</div>
                    <div class="right-part-item-value">1套</div>
                </div> -->
            </div>
        </div>
        <div class="bottom-part">
            <div class="bottom-left-part">
                <div>
                    <div>适用家庭</div>
                    <div>屋顶可用面积约 <span class="area-text">{{ value.bottom.area }}m²</span></div>
                    <div v-if="value.bottom.coldArea">制冷面积 <span class="area-text">{{ value.bottom.coldArea }}m²</span></div>
                </div>
            </div>
            <div class="bottom-right-part">
                <div>
                    <div>建议零售价</div>
                    <div class="price">¥{{ formatterPrice(value.bottom.price) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'BlockArea',
    props: {
        value: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {

        }
    },
    methods: {
      formatterPrice(price) {
        var str = price.toString();
        var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
        return str.replace(reg,"$1,");
      }
    }
}
</script>
<style lang='less' scoped>
.block-item{
  text-align: left;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & .top-part{
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    & .top-left-part{
      flex: 3;
      color: #000000;
      font-family: PingFang SC Heavy, PingFang SC Heavy-Heavy;
      font-weight: bold;
      font-size: 10px;
      line-height: 16px;
      // font-size: 14px;
      // font-size: 16px;
    }
    & .top-right-part{
      flex: 9;
      color: #000000;
      font-family: PingFang SC Bold, PingFang SC Bold-Bold;
      font-weight: 700;
      letter-spacing: 1px;
      font-size: 8px;
      line-height: 16px;
      // font-size: 12px;
      // line-height: 24px;
    }
  }
}
.top-left-part-desc{
  font-size: 8px;
  // font-size: 12px;
}
.right-part-list-item{
  display: flex;
  flex-flow: row nowrap;
  & .right-part-item-title{
    flex: 7;
    text-indent: -8px;
    margin-left: 8px;
  }
  & .right-part-item-value{
    flex: 3;
    align-self: center;
  }
}
.bottom-part{
  display: flex;
  flex-flow: row nowrap;
  margin-top: 18px;
  align-items: flex-end;
  color: #000;
}

.bottom-left-part{
  font-size: 9px;
  // font-size: 8px;
  line-height: 1.1;
  // font-size: 12px;
  // font-weight: bold;
  // word-break: break-all;
}
.area-text{
  font-size: 10px;
  // font-size: 9px;
  // font-size: 13px;
  // font-size: 18px;
  font-weight: 800;
}
.bottom-right-part{
  flex: 1;
  text-align: right;
  font-size: 8px;
  // font-size: 12px;
  font-weight: bold;
}
.price{
  font-family: PingFang SC Bold, PingFang SC Bold-Bold;
  font-weight: 700;
  color: #3B9469;
  letter-spacing: 1px;
  font-size: 13px;
  // font-size: 14px;
  // font-size: 20px;
}
</style>